export class CourseType {
    id: string;
    name: string;
    semesterId: number
}

export const COURSE_TYPE: CourseType[] = [
    {
        id: 'summer_school',
        name: 'Summer School',
        semesterId: 2,
    },
    {
        id: 'winter_school',
        name: 'Winter School',
        semesterId: 1,
    },
];




// WEBPACK FOOTER //
// ./src/holiday/models/CourseType.ts